import type { TargetKind } from "./utils/constants";

interface Props {
  scope: TargetKind;
  inferred?: boolean;
}

export default function ScopeIcon({ scope, inferred }: Props) {
  if (inferred) {
    return (
      <div
        title="Scope inferred — no `-- @scope:` header found. Add `-- @scope: tenant` or `-- @scope: registry` to the top of the SQL file."
        className="w-[22px] h-[22px] rounded-md flex items-center justify-center font-extrabold text-[10px] bg-amber-100 text-amber-700 border-2 border-amber-300"
      >
        ?
      </div>
    );
  }

  const isTenant = scope === "tenant";
  return (
    <div
      title={isTenant ? "Tenant scope — applies to one or more tenant DBs" : "Registry scope — applies to cma_registry only"}
      className={`w-[22px] h-[22px] rounded-md flex items-center justify-center font-extrabold text-[8px] border ${
        isTenant
          ? "bg-sky-100 text-sky-700 border-sky-200"
          : "bg-purple-100 text-purple-700 border-purple-200"
      }`}
    >
      {isTenant ? "TEN" : "REG"}
    </div>
  );
}
